import React, { useContext } from "react";
import { DrawModeChangeEvent } from "@mapbox/mapbox-gl-draw";

import { PolygonIcon } from "fond/svg_icons";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";

const PolygonButton: React.FC<IButtonProps> = ({ icon, title = "Draw a polygon" }) => {
  const { map, drawControl } = useContext(MapContext);

  const handleOnClick = () => {
    drawControl.current.changeMode("draw_polygon");
    map?.fire("draw.modechange", { type: "draw.modechange", mode: "draw_polygon" } as DrawModeChangeEvent);
  };

  return (
    <ToolbarToggleButton title={title} value="draw_polygon" onClick={handleOnClick}>
      {icon || <PolygonIcon />}
    </ToolbarToggleButton>
  );
};

export default PolygonButton;
